var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSugarGliderExcited(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_177513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.5 320C219.975 320 269 313.252 269 304.929C269 296.605 219.975 289.857 159.5 289.857C99.0248 289.857 50 296.605 50 304.929C50 313.252 99.0248 320 159.5 320Z",
    fill: "#EDB27C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.713 281.123L124.007 279.831L159.562 244.583V157.293H104.535L92.7035 131.826L90.0538 126.105C44.3929 230.988 122.713 281.123 122.713 281.123Z",
    fill: "url(#paint0_linear_197_177513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.713 281.123L124.007 279.831C58.8121 228.159 81.1188 156.002 92.7035 131.765L90.0538 126.105C44.3929 230.988 122.713 281.123 122.713 281.123Z",
    fill: "url(#paint1_linear_197_177513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.287 281.123L194.993 279.831L159.438 244.583V157.293H214.526L226.358 131.826L229.007 126.167C274.668 230.988 196.287 281.123 196.287 281.123Z",
    fill: "url(#paint2_linear_197_177513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.286 281.123L194.992 279.831C260.187 228.159 237.88 156.002 226.296 131.765L228.945 126.105C274.668 230.988 196.286 281.123 196.286 281.123Z",
    fill: "url(#paint3_linear_197_177513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.619 256.517C260.126 255.533 259.448 254.548 258.585 253.749C257.722 252.949 256.736 252.211 255.627 251.657C254.518 251.104 253.286 250.735 251.93 250.489C251.93 250.489 245.891 248.766 234.307 254.856C229.007 257.624 223.215 259.47 217.238 259.839C210.398 260.269 201.771 259.347 192.836 254.425L190.556 253.011L189.693 255.348L188.153 257.501C187.66 258.116 187.228 258.67 186.674 259.224C186.181 259.777 185.626 260.331 184.887 261.008C185.626 261.869 186.366 262.668 187.167 263.468C187.968 264.268 188.769 265.006 189.632 265.806C190.494 266.544 191.419 267.282 192.343 268.02C193.267 268.758 194.253 269.435 195.301 270.112C196.287 270.788 197.396 271.404 198.443 272.019C199.552 272.634 200.662 273.249 201.832 273.803C203.003 274.356 204.174 274.848 205.406 275.34C206.454 275.771 207.563 276.14 208.672 276.509C209.781 276.878 210.891 277.186 212 277.493C213.109 277.801 214.28 278.047 215.451 278.293C216.621 278.539 217.792 278.724 218.963 278.908C220.134 279.093 221.305 279.216 222.537 279.339C223.708 279.462 224.94 279.523 226.111 279.585C227.282 279.647 228.514 279.647 229.685 279.647C230.856 279.647 232.027 279.585 233.197 279.523C234.491 279.462 235.785 279.339 237.079 279.154C238.374 278.97 239.606 278.785 240.9 278.539C242.132 278.293 243.365 277.986 244.536 277.678C245.706 277.37 246.816 277.001 247.925 276.571C249.034 276.14 250.081 275.71 251.067 275.217C252.053 274.725 252.978 274.172 253.84 273.618C254.888 272.941 255.874 272.203 256.736 271.404C257.599 270.604 258.339 269.743 259.016 268.881C259.633 267.959 260.187 267.036 260.619 266.052C261.05 265.068 261.296 264.083 261.481 263.038C261.666 261.992 261.666 260.946 261.543 259.839C261.481 258.547 261.112 257.501 260.619 256.517Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.646 253.687C257.783 252.887 256.797 252.149 255.688 251.595C254.579 251.042 253.347 250.673 251.991 250.427C251.991 250.427 246.322 248.827 235.477 254.241C238.866 255.532 243.118 257.993 245.274 262.238C245.521 262.73 244.966 263.222 244.535 262.914L242.008 261.376C242.008 261.376 248.109 267.097 245.89 277.124C246.63 276.878 247.369 276.632 248.047 276.386C249.156 275.955 250.204 275.525 251.19 275.033C252.176 274.541 253.1 273.987 253.963 273.433C255.01 272.757 255.996 272.018 256.859 271.219C257.722 270.419 258.461 269.558 259.139 268.697C259.755 267.774 260.31 266.851 260.741 265.867C261.172 264.883 261.419 263.898 261.604 262.853C261.789 261.807 261.789 260.761 261.665 259.654C261.542 258.547 261.234 257.501 260.679 256.517C260.125 255.471 259.447 254.548 258.646 253.687Z",
    fill: "#332D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.619 256.517C260.126 255.533 259.449 254.548 258.586 253.749C257.785 252.949 256.861 252.272 255.813 251.78C255.936 251.903 256.121 252.026 256.244 252.149C257.045 252.949 257.723 253.933 258.216 254.918C258.709 255.902 259.017 257.009 259.141 258.055C259.264 259.162 259.264 260.208 259.079 261.254C258.956 262.299 258.648 263.284 258.278 264.268C257.908 265.252 257.354 266.175 256.737 267.036C256.121 267.897 255.382 268.758 254.519 269.558C253.656 270.358 252.732 271.096 251.684 271.773C250.822 272.326 249.897 272.88 248.912 273.372C247.926 273.864 246.94 274.295 245.83 274.725C244.783 275.156 243.674 275.525 242.503 275.833C241.332 276.14 240.161 276.448 238.929 276.694C237.697 276.94 236.464 277.124 235.232 277.309C233.999 277.493 232.705 277.555 231.411 277.678C230.24 277.74 229.131 277.801 227.96 277.801C226.79 277.801 225.619 277.801 224.448 277.74C223.277 277.678 222.107 277.617 220.936 277.493C219.765 277.37 218.594 277.247 217.423 277.063C216.253 276.878 215.082 276.694 213.973 276.448C212.863 276.202 211.693 275.956 210.583 275.648C209.474 275.34 208.365 275.033 207.256 274.664C206.147 274.295 205.099 273.926 204.052 273.495C202.881 273.003 201.71 272.511 200.539 271.957C199.43 271.404 198.321 270.788 197.212 270.173C196.164 269.558 195.117 268.881 194.131 268.266C193.145 267.59 192.159 266.913 191.235 266.175C190.31 265.437 189.448 264.698 188.585 263.96C187.722 263.222 186.921 262.422 186.12 261.623C185.812 261.315 185.565 261.007 185.257 260.7C185.134 260.823 185.072 260.884 184.949 261.007C185.689 261.869 186.428 262.668 187.229 263.468C188.03 264.268 188.831 265.006 189.694 265.806C190.557 266.544 191.481 267.282 192.405 268.02C193.33 268.758 194.316 269.435 195.363 270.112C196.349 270.788 197.458 271.404 198.506 272.019C199.615 272.634 200.724 273.249 201.895 273.803C203.066 274.356 204.237 274.848 205.469 275.34C206.516 275.771 207.626 276.14 208.735 276.509C209.844 276.878 210.953 277.186 212.062 277.493C213.172 277.801 214.342 278.047 215.513 278.293C216.684 278.539 217.855 278.724 219.025 278.908C220.196 279.093 221.367 279.216 222.599 279.339C223.77 279.462 225.003 279.523 226.173 279.585C227.344 279.646 228.577 279.646 229.747 279.646C230.918 279.646 232.089 279.585 233.26 279.523C234.554 279.462 235.848 279.339 237.142 279.154C238.436 278.97 239.668 278.785 240.962 278.539C242.195 278.293 243.427 277.986 244.598 277.678C245.769 277.37 246.878 277.001 247.987 276.571C249.096 276.14 250.144 275.71 251.13 275.217C252.116 274.725 253.04 274.172 253.903 273.618C254.95 272.941 255.936 272.203 256.799 271.404C257.662 270.604 258.401 269.743 259.079 268.881C259.695 267.959 260.25 267.036 260.681 266.052C261.112 265.067 261.359 264.083 261.544 263.037C261.729 261.992 261.729 260.946 261.605 259.839C261.482 258.547 261.112 257.501 260.619 256.517Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.199 296.01C104.597 290.104 111.807 284.199 122.59 281.062H136.27C133.744 293.672 119.016 303.268 110.328 300.316C108.356 299.639 106.754 298.04 106.199 296.01Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.36 281.123C130.663 292.503 117.168 300.808 109.034 298.04C107.925 297.671 107 296.994 106.199 296.133C106.754 298.101 108.356 299.701 110.328 300.377C119.078 303.391 133.805 293.734 136.27 281.123H134.36Z",
    fill: "#334E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.76 230.25C215.76 229.697 215.698 229.082 215.698 228.528C215.575 226.313 215.39 224.099 215.082 221.884C215.02 221.331 214.958 220.777 214.835 220.162C214.774 219.608 214.65 219.055 214.589 218.501C214.527 217.947 214.404 217.394 214.342 216.84C214.219 216.287 214.157 215.733 214.034 215.241C213.911 214.687 213.788 214.133 213.726 213.518C213.603 212.965 213.48 212.411 213.356 211.857C213.233 211.304 213.11 210.75 212.987 210.197C212.802 209.52 212.678 208.782 212.494 208.105C212.432 207.674 212.309 207.305 212.247 206.875C205.407 179.193 191.358 153.172 193.268 135.456H159.5H125.732C127.642 153.172 113.592 179.132 106.752 206.875C106.691 207.305 106.568 207.674 106.506 208.105C106.321 208.782 106.198 209.52 106.013 210.197C105.89 210.75 105.767 211.304 105.643 211.857C105.52 212.411 105.397 212.965 105.274 213.518C105.15 214.072 105.027 214.626 104.965 215.241C104.842 215.794 104.781 216.348 104.657 216.84C104.534 217.394 104.473 217.947 104.411 218.501C104.349 219.055 104.226 219.608 104.164 220.162C104.103 220.716 103.98 221.269 103.918 221.884C103.61 224.099 103.425 226.313 103.302 228.528C103.24 229.082 103.24 229.697 103.24 230.25C102.562 247.782 107.122 265.252 122.589 281.123H136.269C136.454 268.02 144.896 260.024 159.5 259.962C174.104 259.962 182.546 268.02 182.731 281.123H196.411C211.816 265.252 216.437 247.721 215.76 230.25Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M215.759 230.25C215.759 229.697 215.697 229.082 215.697 228.528C215.574 226.313 215.389 224.099 215.081 221.884C215.02 221.331 214.958 220.777 214.835 220.162C214.773 219.608 214.65 219.055 214.588 218.501C214.527 217.947 214.403 217.394 214.342 216.84C214.219 216.287 214.157 215.733 214.034 215.241C213.91 214.687 213.787 214.133 213.726 213.518C213.602 212.965 213.479 212.411 213.356 211.857C213.233 211.304 213.109 210.75 212.986 210.197C212.801 209.52 212.678 208.782 212.493 208.105C212.432 207.674 212.308 207.305 212.247 206.875C205.407 179.193 191.357 153.172 193.267 135.456H188.954C187.783 153.48 201.34 179.316 208.056 206.813C208.118 207.244 208.241 207.613 208.303 208.044C208.488 208.782 208.611 209.458 208.796 210.197C208.919 210.75 209.042 211.304 209.166 211.857C209.289 212.411 209.412 212.965 209.535 213.518C209.659 214.072 209.782 214.687 209.843 215.241C209.967 215.794 210.028 216.348 210.152 216.902C210.275 217.455 210.336 218.009 210.398 218.563C210.46 219.116 210.583 219.67 210.645 220.285C210.706 220.839 210.829 221.454 210.891 222.007C211.199 224.283 211.384 226.498 211.507 228.774C211.569 229.328 211.569 229.943 211.569 230.496C212.247 247.844 207.933 265.191 193.452 281H196.472C211.815 265.252 216.437 247.721 215.759 230.25Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.589 281.123H125.608C111.127 265.314 106.814 247.967 107.492 230.619C107.492 230.066 107.553 229.451 107.553 228.897C107.676 226.621 107.861 224.406 108.169 222.13C108.231 221.577 108.293 220.962 108.416 220.408C108.478 219.854 108.601 219.301 108.662 218.686C108.724 218.132 108.847 217.578 108.909 217.025C109.032 216.471 109.094 215.917 109.217 215.364C109.34 214.81 109.463 214.195 109.525 213.641C109.648 213.088 109.772 212.534 109.895 211.98C110.018 211.427 110.141 210.873 110.265 210.32C110.449 209.581 110.573 208.905 110.757 208.167C110.819 207.736 110.942 207.367 111.004 206.936C117.721 179.378 131.216 153.541 130.106 135.579H125.793C127.703 153.295 113.654 179.255 106.814 206.998C106.752 207.428 106.629 207.797 106.567 208.228C106.382 208.905 106.259 209.643 106.074 210.32C105.951 210.873 105.828 211.427 105.705 211.98C105.581 212.534 105.458 213.088 105.335 213.641C105.212 214.195 105.088 214.749 105.027 215.364C104.904 215.917 104.842 216.471 104.719 216.963C104.595 217.517 104.534 218.07 104.472 218.624C104.411 219.178 104.287 219.731 104.226 220.285C104.164 220.839 104.041 221.392 103.979 222.007C103.671 224.222 103.486 226.436 103.363 228.651C103.301 229.205 103.301 229.82 103.301 230.373C102.562 247.721 107.183 265.252 122.589 281.123Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.801 296.01C214.404 290.104 207.194 284.199 196.41 281.062H182.73C185.257 293.672 199.984 303.268 208.673 300.316C210.645 299.639 212.247 298.04 212.801 296.01Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.641 281.123C188.338 292.503 201.833 300.808 209.967 298.04C211.076 297.671 212 296.994 212.801 296.133C212.247 298.101 210.645 299.701 208.673 300.377C199.923 303.391 185.195 293.734 182.73 281.123H184.641Z",
    fill: "#334E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.501 204.599C194.316 174.272 181.006 159.016 181.561 135.518H159.501H137.44C137.995 158.955 124.746 174.272 124.5 204.599C124.5 204.906 124.5 205.152 124.5 205.46C124.5 223.545 140.152 238.247 159.501 238.247C178.849 238.247 194.501 223.545 194.501 205.46C194.501 205.152 194.501 204.906 194.501 204.599Z",
    fill: "url(#paint4_radial_197_177513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.244 56.3475L216.253 50.9957L202.881 36.6627L190.434 23.2525C200.971 1.41475 225.373 -5.41339 233.876 4.36746C245.831 18.0237 237.08 45.3978 221.244 56.3475Z",
    fill: "url(#paint5_radial_197_177513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.252 50.9953L202.88 36.6623C203.866 37.0314 204.791 37.462 205.715 37.8926C206.639 38.3232 207.687 38.8769 208.611 38.1387C209.104 37.7696 209.351 37.0929 209.289 36.4163C209.166 35.063 208.118 34.1402 207.071 33.3405L210.953 32.9099C211.939 32.7869 212.432 31.5566 211.754 30.8184C210.953 30.0187 209.967 29.4036 208.858 29.0345C207.071 28.4194 205.16 28.4194 203.312 28.4194C204.975 27.8657 206.701 27.3121 208.426 26.7585C208.919 26.5739 209.412 26.3894 209.659 25.9588C209.905 25.4666 209.597 24.79 209.166 24.4209C208.673 24.0518 208.057 23.9903 207.502 23.9288C205.468 23.7442 203.373 23.8057 201.34 24.1748C209.227 11.6873 222.537 4.18252 228.638 8.98068C238.374 19.3152 225.68 43.7365 216.252 50.9953Z",
    fill: "url(#paint6_linear_197_177513)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.754 35.617C229.687 44.5982 223.463 51.6724 208.613 37.2164C200.355 29.1579 191.42 23.3755 190.619 22.9449C190.558 23.068 190.496 23.1295 190.496 23.191L202.943 36.6012L216.315 50.9342L221.306 56.286C236.404 45.89 245.03 20.5459 235.541 6.39746C239.423 15.1326 237.266 27.8661 233.754 35.617Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8197 56.3475L102.811 50.9957L116.183 36.6627L128.63 23.2525C118.093 1.41475 93.6911 -5.41339 85.1875 4.36746C73.2331 18.0237 81.9832 45.3978 97.8197 56.3475Z",
    fill: "url(#paint7_radial_197_177513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.813 50.9953L116.185 36.6623C115.199 37.0314 114.274 37.462 113.35 37.8926C112.426 38.3232 111.378 38.8769 110.454 38.1387C109.961 37.7696 109.714 37.0929 109.776 36.4163C109.899 35.063 110.947 34.1402 111.994 33.3405L108.112 32.9099C107.126 32.7869 106.633 31.5566 107.311 30.8184C108.112 30.0187 109.098 29.4036 110.207 29.0345C111.994 28.4194 113.905 28.4194 115.753 28.4194C114.09 27.8657 112.364 27.3121 110.639 26.7585C110.146 26.5739 109.653 26.3894 109.406 25.9588C109.16 25.4666 109.468 24.79 109.899 24.4209C110.392 24.0518 111.008 23.9903 111.563 23.9288C113.597 23.7442 115.692 23.8057 117.725 24.1748C109.776 11.6873 96.5276 4.18252 90.4272 8.98068C80.6295 19.3152 93.385 43.7365 102.813 50.9953Z",
    fill: "url(#paint8_linear_197_177513)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3118 35.617C89.3788 44.5982 95.6025 51.6724 110.453 37.2164C118.71 29.1579 127.645 23.3755 128.446 22.9449C128.508 23.068 128.57 23.1295 128.57 23.191L116.122 36.6012L102.812 50.9957L97.8208 56.3475C82.7238 45.9515 74.0969 20.6074 83.5865 6.39746C79.6427 15.1326 81.7995 27.8661 85.3118 35.617Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.687 62.7451C209.537 39.554 192.838 13.9639 160.056 13.9639C159.871 13.9639 159.686 13.9639 159.501 13.9639C159.316 13.9639 159.131 13.9639 158.946 13.9639C126.164 13.9639 109.527 39.554 89.315 62.7451C67.6245 88.7044 84.6318 113.433 92.0879 120.507C109.711 137.24 135.346 146.59 159.563 146.651C183.78 146.59 209.352 137.178 227.037 120.507C234.432 113.495 251.377 88.7659 229.687 62.7451Z",
    fill: "url(#paint9_radial_197_177513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.223 86.9199C240.223 87.289 240.284 87.7196 240.284 88.0887C240.284 87.7196 240.284 87.3505 240.223 86.9199Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.977 84.583C240.038 85.2597 240.161 85.9363 240.223 86.5515C240.161 85.8748 240.1 85.1982 239.977 84.583Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.694 122.599C224.509 122.783 224.263 122.968 224.078 123.091C224.263 122.906 224.509 122.783 224.694 122.599Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.223 86.6738C240.223 86.6123 240.223 86.5508 240.223 86.5508C240.223 86.6738 240.223 86.7968 240.284 86.9814C240.223 86.8584 240.223 86.7968 240.223 86.6738Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.98 84.3984C239.98 84.3369 239.98 84.2139 239.918 84.1523C239.918 84.2754 239.98 84.4599 239.98 84.5829C239.98 84.5214 239.98 84.4599 239.98 84.3984Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.348 88.2119C240.348 88.1504 240.348 88.1504 240.348 88.0889C240.286 88.1504 240.348 88.2119 240.348 88.2119Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.855 83.5986C239.855 83.4756 239.793 83.414 239.793 83.291C239.855 83.4756 239.855 83.7216 239.916 83.9062C239.855 83.7831 239.855 83.7216 239.855 83.5986Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.79 120.692C226.113 121.369 225.373 121.984 224.695 122.599C225.373 121.984 226.113 121.308 226.79 120.692Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.085 119.4L228.023 119.462C228.023 119.462 228.085 119.462 228.085 119.4Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.023 119.462C227.838 119.646 227.654 119.831 227.469 120.016C227.654 119.893 227.838 119.708 228.023 119.462Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.347 91.042C240.347 91.4111 240.347 91.7802 240.285 92.0877C240.285 91.7802 240.285 91.4111 240.347 91.042Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.287 92.334C240.287 92.7646 240.226 93.1337 240.164 93.5028C240.226 93.1337 240.226 92.7646 240.287 92.334Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.812 117.493C229.689 117.616 229.627 117.739 229.504 117.862C229.566 117.739 229.689 117.616 229.812 117.493Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.997 117.247C230.244 116.939 230.49 116.693 230.675 116.386C230.367 116.755 230.059 117.124 229.812 117.493C229.874 117.431 229.936 117.37 229.997 117.247Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.503 117.862C229.01 118.416 228.579 118.97 228.086 119.4C228.517 118.908 229.01 118.416 229.503 117.862Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.905 114.663L231.844 114.725C231.905 114.725 231.905 114.725 231.905 114.663Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.773 106.113C236.773 106.113 236.773 106.175 236.711 106.175C236.773 106.175 236.773 106.175 236.773 106.113Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.976 120.507C209.353 137.239 183.718 146.589 159.501 146.651C135.284 146.589 109.712 137.177 92.0267 120.507C86.5424 115.278 75.8204 100.515 79.3328 82.6754C88.0213 66.743 108.233 69.0191 121.974 80.7684C123.946 82.4293 125.795 84.0287 127.643 85.505C127.828 85.6281 140.152 95.0398 146.499 89.0114C154.633 81.322 144.836 35.7396 128.383 22.883C132.019 20.5454 135.901 18.5769 140.091 17.1006C146.561 30.8184 156.605 59.5458 157.037 84.3978C157.037 84.4593 157.037 84.5208 157.037 84.6438C157.037 92.5792 159.44 92.0871 159.44 92.0871C159.44 92.0871 161.843 92.5792 161.843 84.6438C161.843 84.5823 161.843 84.4593 161.843 84.3978C162.274 59.6073 172.318 30.8184 178.789 17.1006C182.979 18.5769 186.861 20.5454 190.497 22.883C174.105 35.7396 164.246 81.322 172.38 89.0114C178.727 94.9783 191.051 85.6281 191.236 85.505C193.085 83.9672 194.933 82.4293 196.905 80.7684C210.647 69.0191 230.92 66.743 239.547 82.6754C243.121 100.515 232.46 115.34 226.976 120.507Z",
    fill: "url(#paint10_radial_197_177513)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.078 67.2354C244.355 89.6883 230.86 109.681 224.513 115.955C207.506 132.687 182.796 142.037 159.503 142.099C136.149 142.037 111.501 132.626 94.4933 115.955C88.1463 109.742 74.6514 89.7498 85.928 67.2354C69.5369 91.5337 85.0037 113.864 92.0901 120.507C109.714 137.239 135.348 146.589 159.565 146.651C183.782 146.589 209.354 137.178 227.039 120.507C234.003 113.864 249.469 91.5337 233.078 67.2354Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.443 93.1945C172.443 97.6236 164.309 103.098 159.503 103.098C154.327 103.098 146.562 97.5621 146.562 93.1945C146.562 88.827 155.99 87.4736 159.503 87.4736C163.015 87.5351 172.443 88.827 172.443 93.1945Z",
    fill: "url(#paint11_linear_197_177513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.503 91.6569C162.429 91.6569 164.802 91.2163 164.802 90.6727C164.802 90.1291 162.429 89.6885 159.503 89.6885C156.576 89.6885 154.203 90.1291 154.203 90.6727C154.203 91.2163 156.576 91.6569 159.503 91.6569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.516 90.7957C221.234 90.7957 225.869 88.8953 225.869 86.5512C225.869 84.207 221.234 82.3066 215.516 82.3066C209.799 82.3066 205.164 84.207 205.164 86.5512C205.164 88.8953 209.799 90.7957 215.516 90.7957Z",
    fill: "#F2857C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.489 90.7957C109.206 90.7957 113.841 88.8953 113.841 86.5512C113.841 84.207 109.206 82.3066 103.489 82.3066C97.7716 82.3066 93.1367 84.207 93.1367 86.5512C93.1367 88.8953 97.7716 90.7957 103.489 90.7957Z",
    fill: "#F2857C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.43 122.292C164.43 126.044 162.211 127.336 159.5 127.336C156.789 127.336 154.57 125.983 154.57 122.292C154.57 118.601 156.789 113.803 159.5 113.803C162.211 113.803 164.43 118.539 164.43 122.292Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.053 59.0545C204.053 54.5639 200.541 50.873 196.166 50.873C193.947 50.873 191.914 51.8573 190.497 53.3952C190.065 53.8258 189.449 53.8258 189.018 53.3952C187.231 51.4882 184.643 50.504 181.747 51.0576C178.481 51.6727 175.954 54.5024 175.523 57.8857C175.153 60.7769 176.201 63.4221 178.111 65.206L188.71 75.1714C189.326 75.725 190.189 75.725 190.805 75.1714L201.404 65.206C203.006 63.6681 204.053 61.4536 204.053 59.0545Z",
    fill: "#F70606"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.542 59.0545C143.542 54.5639 140.029 50.873 135.654 50.873C133.436 50.873 131.402 51.8573 129.985 53.3952C129.554 53.8258 128.937 53.8258 128.506 53.3952C126.719 51.4882 124.131 50.504 121.235 51.0576C117.969 51.6727 115.442 54.5024 115.011 57.8857C114.641 60.7769 115.689 63.4221 117.599 65.206L128.198 75.1714C128.814 75.725 129.677 75.725 130.293 75.1714L140.892 65.206C142.494 63.6681 143.542 61.4536 143.542 59.0545Z",
    fill: "#F70606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.443 125.797L217.917 123.337C217.917 123.337 214.959 111.895 220.258 104.698C224.325 99.1615 234 102.176 234.739 108.02C235.417 113.864 232.213 117.985 232.213 117.985L233.876 117.308C235.17 117.001 236.28 118.293 235.663 119.461C234.924 120.938 233.383 122.845 230.241 124.936C223.339 129.488 220.443 125.797 220.443 125.797Z",
    fill: "url(#paint12_linear_197_177513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.145 140.807C193.329 144.621 194.007 148.743 195.116 153.11C195.856 156.124 196.78 159.262 197.828 162.522L215.821 165.105C221.552 165.905 226.728 161.661 227.098 155.94L229.008 126.228L229.069 125.798L227.775 125.49L226.173 125.182L217.978 123.46L216.314 133.487L214.28 146.036L193.884 140.684L193.145 140.807Z",
    fill: "url(#paint13_linear_197_177513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.443 125.797L217.917 123.337C217.917 123.337 214.959 111.895 220.258 104.698C224.325 99.1615 234 102.176 234.739 108.02C235.417 113.864 232.213 117.985 232.213 117.985L233.876 117.308C235.17 117.001 236.28 118.293 235.663 119.461C234.924 120.938 233.383 122.845 230.241 124.936C223.339 129.488 220.443 125.797 220.443 125.797Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.145 140.807C193.329 144.621 194.007 148.743 195.116 153.11C195.856 156.124 196.78 159.262 197.828 162.522L215.821 165.105C221.552 165.905 226.728 161.661 227.098 155.94L229.008 126.228L229.069 125.798L227.775 125.49L226.173 125.182L217.978 123.46L216.314 133.487L214.28 146.036L193.884 140.684L193.145 140.807Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M195.117 153.048C195.857 156.063 196.781 159.2 197.828 162.46L215.822 165.044C221.552 165.844 226.729 161.599 227.098 155.878L229.009 126.167L229.07 125.736C229.44 125.49 229.81 125.305 230.241 124.998C233.384 122.906 234.924 120.999 235.664 119.523C236.28 118.354 235.171 117.001 233.877 117.37L232.213 118.047C232.398 117.8 235.417 113.741 234.739 108.081C234.616 107.158 234.308 106.297 233.815 105.559C233.63 105.251 233.384 105.005 233.199 104.759C232.336 103.837 231.227 103.098 229.995 102.606C229.871 102.545 229.748 102.483 229.625 102.483C229.502 102.422 229.378 102.422 229.317 102.36C229.193 102.299 229.07 102.299 228.947 102.237C228.7 102.176 228.454 102.114 228.208 102.053C227.53 101.93 226.852 101.868 226.112 101.868C226.112 101.868 237.081 104.944 227.53 120.938C227.53 120.938 228.392 123.583 226.174 124.752C226.174 124.752 226.174 124.875 226.112 125.121C226.051 125.49 225.989 126.167 225.928 127.028C225.25 133.917 223.216 154.156 222.662 155.94C220.875 161.476 217.362 160.922 207.688 159.323C199.307 157.97 197.52 156.37 195.117 153.048Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6181 125.797L101.145 123.337C101.145 123.337 104.102 111.895 98.8029 104.698C94.7359 99.1615 85.0615 102.176 84.3221 108.02C83.6442 113.864 86.8485 117.985 86.8485 117.985L85.1847 117.308C83.8907 117.001 82.7815 118.293 83.3977 119.461C84.1372 120.938 85.6777 122.845 88.8204 124.936C95.6603 129.488 98.6181 125.797 98.6181 125.797Z",
    fill: "url(#paint14_linear_197_177513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.855 140.807C125.671 144.621 124.993 148.743 123.884 153.11C123.144 156.124 122.22 159.262 121.172 162.522L103.179 165.105C97.4483 165.905 92.2722 161.661 91.9024 155.94L90.0538 126.105L89.9922 125.674L91.2862 125.367L92.8884 125.059L101.084 123.337L102.748 133.364L104.781 145.913L125.178 140.561L125.855 140.807Z",
    fill: "url(#paint15_linear_197_177513)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6181 125.797L101.145 123.337C101.145 123.337 104.102 111.895 98.8029 104.698C94.7359 99.1615 85.0615 102.176 84.3221 108.02C83.6442 113.864 86.8485 117.985 86.8485 117.985L85.1847 117.308C83.8907 117.001 82.7815 118.293 83.3977 119.461C84.1372 120.938 85.6777 122.845 88.8204 124.936C95.6603 129.488 98.6181 125.797 98.6181 125.797Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.855 140.807C125.671 144.621 124.993 148.743 123.884 153.11C123.144 156.124 122.22 159.262 121.172 162.522L103.179 165.105C97.4483 165.905 92.2722 161.661 91.9024 155.94L90.0538 126.105L89.9922 125.674L91.2862 125.367L92.8884 125.059L101.084 123.337L102.748 133.364L104.781 145.913L125.178 140.561L125.855 140.807Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M123.883 153.048C123.143 156.063 122.219 159.2 121.171 162.46L103.178 165.044C97.4473 165.844 92.2711 161.599 91.9014 155.878L90.0528 126.105L89.9912 125.674C89.6214 125.428 89.2517 125.244 88.8204 124.936C85.6777 122.845 84.1372 120.938 83.3977 119.461C82.7815 118.293 83.8907 116.939 85.1847 117.308L86.8485 117.985C86.6636 117.739 83.6442 113.679 84.3221 108.02C84.4453 107.097 84.7534 106.236 85.2464 105.498C85.4312 105.19 85.6777 104.944 85.8626 104.698C86.7253 103.775 87.8344 103.037 89.0668 102.545C89.1901 102.483 89.3133 102.422 89.4366 102.422C89.5598 102.36 89.6831 102.36 89.7447 102.299C89.8679 102.237 89.9912 102.237 90.1144 102.176C90.3609 102.114 90.6074 102.053 90.8538 101.991C91.5317 101.868 92.2095 101.807 92.9489 101.807C92.9489 101.807 81.9805 104.882 91.5317 120.876C91.5317 120.876 90.669 123.521 92.8873 124.69C92.8873 124.69 92.8873 124.813 92.9489 125.059C93.0106 125.428 93.0722 126.105 93.1338 126.966C93.8116 133.856 95.8451 154.094 96.3997 155.878C98.1867 161.414 101.699 160.861 111.374 159.261C119.754 157.97 121.479 156.37 123.883 153.048Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_177513",
    x1: 44.3412,
    y1: 195.777,
    x2: 103.558,
    y2: 203.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#F3DFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6253,
    stopColor: "#EED8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#E6CBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_177513",
    x1: 133.529,
    y1: 275.938,
    x2: 67.044,
    y2: 137.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3652,
    stopColor: "#605A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6066,
    stopColor: "#575154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8114,
    stopColor: "#494346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#332D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_197_177513",
    x1: 274.674,
    y1: 195.777,
    x2: 215.458,
    y2: 203.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#F3DFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6253,
    stopColor: "#EED8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#E6CBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_197_177513",
    x1: 185.486,
    y1: 275.938,
    x2: 251.971,
    y2: 137.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3652,
    stopColor: "#605A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6066,
    stopColor: "#575154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8114,
    stopColor: "#494346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#332D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_197_177513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.652 140.504) rotate(90) scale(90.1742 41.2264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#F3DFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6253,
    stopColor: "#EED8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#E6CBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_197_177513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(213.407 9.39002) scale(37.2434 37.1794)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5212,
    stopColor: "#615B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#5A5457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8427,
    stopColor: "#4F494B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9501,
    stopColor: "#3E383B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_197_177513",
    x1: 196.202,
    y1: 28.0492,
    x2: 228.203,
    y2: 29.6521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF669A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#FF8AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CBD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_197_177513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.645 9.39002) rotate(180) scale(37.2434 37.1794)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5212,
    stopColor: "#615B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#5A5457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8427,
    stopColor: "#4F494B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9501,
    stopColor: "#3E383B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_197_177513",
    x1: 122.851,
    y1: 28.0492,
    x2: 90.8494,
    y2: 29.6521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF669A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#FF8AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CBD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_197_177513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.468 87.0834) rotate(-90) scale(71.3624 88.8919)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363052,
    stopColor: "#352F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6595,
    stopColor: "#565053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635D5F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_197_177513",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.249 51.2312) scale(96.7589 96.5926)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F3DFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7208,
    stopColor: "#EFDAC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8569,
    stopColor: "#E9D0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    stopColor: "#E1C3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_197_177513",
    x1: 159.514,
    y1: 100.572,
    x2: 159.514,
    y2: 86.8508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF669A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#FF8AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_197_177513",
    x1: 185.771,
    y1: 133.071,
    x2: 222.563,
    y2: 133.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5CEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3406,
    stopColor: "#B5CCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#B4C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    stopColor: "#B2B6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    stopColor: "#B0A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8985,
    stopColor: "#AD8AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#AA6CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA6CE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_197_177513",
    x1: 185.771,
    y1: 133.071,
    x2: 222.562,
    y2: 133.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5CEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3406,
    stopColor: "#B5CCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#B4C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    stopColor: "#B2B6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    stopColor: "#B0A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8985,
    stopColor: "#AD8AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#AA6CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA6CE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_197_177513",
    x1: 133.245,
    y1: 133.071,
    x2: 96.4526,
    y2: 133.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5CEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3406,
    stopColor: "#B5CCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#B4C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    stopColor: "#B2B6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    stopColor: "#B0A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8985,
    stopColor: "#AD8AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#AA6CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA6CE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_197_177513",
    x1: 133.246,
    y1: 133.071,
    x2: 96.4536,
    y2: 133.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5CEE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3406,
    stopColor: "#B5CCE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5215,
    stopColor: "#B4C4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6649,
    stopColor: "#B2B6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7886,
    stopColor: "#B0A3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8985,
    stopColor: "#AD8AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#AA6CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA6CE0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_177513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 219,
    height: 320,
    fill: "white",
    transform: "translate(50)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugarGliderExcited);
export default __webpack_public_path__ + "static/media/sugarGlider_excited.3119b45340714368c9bbccea80e219ef.svg";
export { ForwardRef as ReactComponent };